import React from 'react'
import "./Home.css"
const Home = () => {
  return (
    <>
      <div>Hello</div>
    </>
  )
}

export default Home
